import isEqual from "lodash.isequal";
import React from "react";
import { connect } from "react-redux";
import { getPromotions } from "../../../Home/actions/catalogs";
import { getPromotionsFiltered } from "../../../Home/actions/promotions";
import { PromotionSelector } from "../../components/PromotionSelector";
import { QUOTATION_TYPE } from "../../../utils/constants";
import { Partner } from "../../../Home/components/partners/interfaces";

interface Props {
  getPromotionsFiltered: (params: object) => any;
  getPromotions: () => any;
  loading: boolean;
  title: string;
  promotions: object[];
  disabled: boolean;
  excludePromotionId: number;
  onChange: (value: string) => any;
  value: { id: number };
  params: {
    club: string;
    membresia: string;
    mantenimiento: string;
    convenio?: string;
  };
  quotationUse: string;
  promotionType: string;
  partner: Partner;
}

const getPromotion = (promotions: any, promocion: any) => {
  return promotions.find(({ id }) => id == promocion);
};

class MaintenanceSelectorContainer extends React.Component<Props> {
  componentDidMount() {
    this.loadPromorions(this.props.params);
  }

  componentDidUpdate({ params: prevParams }) {
    const { params } = this.props;
    if (!isEqual(params, prevParams)) {
      this.loadPromorions(params);
    }
  }

  loadPromorions = params => {
    if (!this.props.disabled && !this.props.loading) {
      if (params.club && params.membresia && params.mantenimiento) {
        params.tipoCotizacion =
          this.props.quotationUse == QUOTATION_TYPE.RECOTIZACION
            ? QUOTATION_TYPE.VENTA
            : this.props.quotationUse;
        this.props.getPromotionsFiltered(params);
      } else {
        this.props.getPromotions();
      }
    }
  };

  getPromotionsFiltered = () => {
    let filtered = [...(this.props.promotions || [])];

    console.info(filtered);

    if (!!this.props.quotationUse) {
      let quotUse =
        this.props.quotationUse == QUOTATION_TYPE.RECOTIZACION
          ? QUOTATION_TYPE.VENTA
          : this.props.quotationUse;

      filtered = filtered.filter(
        x =>
          x.tipoUsoPromocion == quotUse &&
          !!x.autorizada &&
          x.id != (this.props.excludePromotionId || 0)
      );
    }

    console.info(filtered);

    if (!!this.props.promotionType) {
      switch (this.props.promotionType) {
        case "PRINCIPAL":
          filtered = filtered.filter(x => !!x.principal);
          break;
        case "ALTERNA":
          filtered = filtered.filter(x => !!x.alterna);
          break;
      }
    }

    console.info(filtered);

    if (this.props.quotationUse == QUOTATION_TYPE.REACTIVACION) {
      const mesesSinPago = this.props.partner.mesesSinPago || 100;
      console.info("Meses sin pago: ");
      console.info(mesesSinPago);
      filtered = filtered.filter(
        x =>
          (x.maxMesesSinPago || 0) == 0 ||
          (x.maxMesesSinPago || 0) < mesesSinPago
      );
    }

    console.info(filtered);

    return filtered;
  };

  render() {
    return (
      <PromotionSelector
        value={this.props.value}
        title={this.props.title}
        promotions={this.getPromotionsFiltered()}
        onChange={value => {
          const promotionObject = getPromotion(this.props.promotions, value);
          this.props.onChange(promotionObject);
        }}
        disabled={this.props.disabled || this.props.loading}
      />
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getPromotionsFiltered: (params: object) => {
    dispatch(getPromotionsFiltered(params));
  },
  getPromotions: () => {
    dispatch(getPromotions());
  }
});

const mapStateToProps = state => {
  const {
    catalogs: { promotions, gettingPromotions },
    promotions: { gettingPromotionsFiltered, promotionsFiltered }
  } = state;

  return {
    promotions: promotions || promotionsFiltered,
    loading: gettingPromotions || gettingPromotionsFiltered
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MaintenanceSelectorContainer);
